interface Props {
  width?: number,
  height?: number,
  stroke?: string,
}

const Announcement = ({
  width = 48,
  height = 48,
  stroke = '#231f20',
  ...rest
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    height={height}
    width={width}
    {...rest}
  >
    <title id="title6">Announcement</title>
    <g
      id="g908"
      style={{
        stroke,
        strokeOpacity: 1,
        strokeWidth: 2.44641663,
        strokeMiterlimit: 4,
        strokeDasharray: 'none',
      }}
      transform="translate(-15.2 22) scale(.43)"
    >
      <path
        id="path406"
        d="M71.185-20.073c-1.361-1.672-3.22-3.964-3.22-6.379v-7.556c0-6.564-4.892-11.89-11.146-11.89-6.256 0-11.086 5.326-11.086 11.89v7.618c0 2.353-2.044 4.582-3.282 6.254-1.178 1.55-2.044 2.787-1.424 3.964.557 1.052 1.918 1.239 3.033 1.239h25.887c.68 0 2.354 0 2.912-1.177.557-1.24-.372-2.415-1.674-3.963z"
        style={{
          fill: 'none',
          stroke,
          strokeWidth: 2.44641663,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
      />
      <path
        id="path410"
        d="M50.144-14.933a6.925 6.925 0 0 0 13.556 0z"
        style={{
          fill: 'none',
          stroke,
          strokeWidth: 2.44641663,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
      />
    </g>
  </svg>
);

export default Announcement;
